import React, { useContext } from 'react';
import { IModifierGroupsContext, ModifierGroupsContext } from '../../../modifierGroupsState/modifierGroupsContext';
import SearchField from 'components/SearchField/SearchField';

const Search: React.FC = () => {
	const { changeSearchString, searchString, modifiersGroups } =
		useContext<IModifierGroupsContext>(ModifierGroupsContext);

	return (
		<SearchField
			onChangeSelectSearchString={changeSearchString}
			searchString={searchString}
			delay={modifiersGroups.modifierGroupsCount ? 800 : undefined}
		/>
	);
};

export default Search;
